export const ordersHistoryEmptyMessages = [
  {
    'title': '✨ Ще все попереду',
    'description': 'Ваша історія замовлень поки що порожня.<br />Укладіть перший поліс — і почніть будувати свою базу постійних клієнтів.',
  },
];
